<template>
    <div class="my-8">
        <h3 class="text-2xl text-dark my-4">
            <span class="font-bold">Similar tyres</span>
            to
            <template v-if="product.brand">{{ product.brand.name }}</template>
            {{ product.name }}
        </h3>

        <div class="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-8" v-if="comparisons.length > 0">
            <TyreCard v-for="comparison of comparisons" :product="comparison"></TyreCard>
        </div>

        <p v-else>We can't find any similar tyres for this tyre</p>
    </div>
</template>

<script>
import TyreCard from "@/Components/Products/Tyres/TyreCard";

export default {
    components: {TyreCard},
    props: {
        product: Object,
        comparisons: Array
    }
};
</script>

<style scoped>

</style>
